module.exports = __webpack_public_path__ + "static/paprica-2-ba3ec38aca24051050ab3a8c772eead6.png";